module.exports = __webpack_public_path__ + "static/produkty_intenso-bb049bceb9e149621b99579cbefed982.png";